module.exports = __webpack_public_path__ + "assets/img/favicons/android-icon-36x36.png";